// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1rUrZ","resendInfoText":"OnGoingPaymentBox_resendInfoText__2aM-a"};